import { groq } from 'next-sanity';
import { z } from 'zod';

import { form, SanityForm } from './form';
import { image, SanityImage } from './image';

export const SanityGatedContentDownload = z.object({
  _type: z.literal('gatedContentDownload'),
  _key: z.string(),
  media: SanityImage,
  headline: z.string(),
  body: z.string(),
  form: SanityForm.and(z.object({ _id: z.string() })),
  downloadUrl: z.string(),
  downloadButtonLabel: z.string().optional().nullable(),
});
export type SanityGatedContentDownload = z.infer<
  typeof SanityGatedContentDownload
>;

export const gatedContentDownload = groq`{
  _type,
  _key,
  media ${image},
  headline,
  body,
  form-> ${form},
  'downloadUrl': coalesce(externalUrl, file.asset->url),
  'downloadButtonLabel': coalesce(downloadButtonLabel, 'Download'),
}`;
